import _ from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { useGetRecentWiresByCategories } from '../../../services/categories-service';
import { useGetRecentWiresBySeries } from '../../../services/series-service';
import { useGetLivewireEvents } from '../../../services/events-service';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function useCommonProps() {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const isXLarge = useMediaQuery({ query: `(min-width: ${theme.breakpointXlargeMin})` });
  const profile = _.get(window, 'Livewire.currentUser.profile');
  const isUserSignedIn = !!(_.get(profile, 'firstName'));
  const [{ data: categoriesData }] = useGetRecentWiresByCategories();
  const [{ data: seriesData }] = useGetRecentWiresBySeries();
  const [{ data: eventsData }] = useGetLivewireEvents();

  return {
    ...theme,
    isMobile,
    isXLarge,
    isUserSignedIn,
    categoriesData,
    seriesData,
    eventsData,
  };
}
